import { Redirect } from './_shared/Redirect.route';
import { ROUTE_NAMES } from './_shared/routes.constants';
import { TRouteComponent } from './_shared/routes.types';

export const NotFoundRoute: TRouteComponent = routeProps => {
  const [path] = routeProps.route.path.split('?');
  const needToRedirectToNewEditor = path === '/editor-v3';

  return (
    <Redirect
      {...routeProps}
      redirectRouteName={needToRedirectToNewEditor ? ROUTE_NAMES.EditorNew : ROUTE_NAMES.Editor}
    />
  );
};
